import constructEnterpriseDomain from 'utils/construct-enterprise-domain';

/*

# USAGE GUIDE WHEN YOU NEED TO GET TO THE ENTERPRISE LIST aka membership list aka "Switch Enterprises"

Note that the `/enterprises` path is supposed to be used on `app.{brand}…` origins, not {enterprise}.{brand}….
Depends on where you are, choose the right pattern below:

## Same origin → SPA navigation

Use primitives like `navigate()`, `Link`, or `NavLink` together with `ENTERPRISE_LIST_PATH`.
Avoid `goToEnterpriseList()`; it always full-page reloads.

## Same origin → SPA navigation

Use primitives like `navigate()`, `Link`, or `NavLink` together with `ENTERPRISE_LIST_PATH`.
Avoid `goToEnterpriseList()`; it always full-page reloads.

| Call site             | Use                                                 |
| --------------------- | --------------------------------------------------- |
| ExistingSessionPrompt | `navigate(ENTERPRISE_LIST_PATH, { replace: true })` |

Invite links stay on the app host; no host change.

## Cross origin → full URL navigation

| Call site                         | Use                      |
| --------------------------------- | ------------------------ |
| SiteSwitcher “Switch Enterprises” | `goToEnterpriseList()`   |
| ErrorModal “Switch enterprises”   | `goToEnterpriseList()`   |
| Account / More menu link          | `getEnterpriseListUrl()` |

`goToEnterpriseList()` sets `window.location.href` so it leaves the enterprise subdomain.

*/

/** In-app path to the membership list on the current origin. */
export const ENTERPRISE_LIST_PATH = '/enterprises';

/**
 * Full URL to the membership list on the `app.{brand}…` origin (white-label aware).
 * For external links and cross-origin jumps.
 */
export const getEnterpriseListUrl = () => `${constructEnterpriseDomain()}${ENTERPRISE_LIST_PATH}`;

/** Go to the membership list with a full page load. */
export const goToEnterpriseList = () => {
  window.location.href = getEnterpriseListUrl();
};
